export enum VolumeMeasurement {
    Litre,
    Gallon,
    UsGallon
}
